<p>Layers below can be filtered before they are added to map. This is optional and when you are done, select Add Layers.</p>
<div class="filter-item" *ngFor="let layer of filtersAndIds">{{ layer.name }} - {{ layer.id }}<button class="btn btn-primary right" (click)="openFilter(layer.id)">Filter</button></div>
<hr>
<div>
    <button class="right btn btn-primary" (click)="addLayersToMap()">Add Layers</button>
</div>